import cloneDeep from 'lodash.clonedeep';

const INITIAL_STATE = {
  memberHistory: [],
};

export default {
  namespaced: true,

  state: cloneDeep(INITIAL_STATE),

  mutations: {
    resetLimitsAndUsage(state) {
      Object.assign(state, cloneDeep(INITIAL_STATE));
    },

    updateMemberHistory(state, memberHistory) {
      state.memberHistory = memberHistory;
    },
  },

  getters: {
    getMemberHistory: (state) => {
      return state.memberHistory;
    },
  },
};
